/* eslint-disable import/prefer-default-export */

/**
 * checking if file size is exceeding max size in Mb
 * @param {number} fileSize - file size in bytes.
 * @param {number} maxfileSizeInMb.
 * @returns {boolean}
 */
export const validateFileSizeInMb = (fileSize, maxfileSizeInMb = 1) => {
  const size = fileSize / 1024 / 1024; // in MB

  if (size > maxfileSizeInMb) {
    return true;
  }

  return false;
};

// 8-20 characters at least 1 Uppercase Alphabet, 1 Lowercase Alphabet and 1 Number
export const isValidPassword = (password = '') => {
  const pw = password.toString();

  return (
    pw.length >= 8
    && pw.length <= 20
    && pw.match(/[a-z]/)
    && pw.match(/[A-Z]/)
    && pw.match(/\d/)
    && !pw.match(/\s/)
  );
};

// 8-20 characters (letters (upper- and lowercase) and numbers and special characters)
export const isValidPasswordES = (password = '') => password.match(
  /^(?=.*\d)(?=.*[a-z])[\da-z!@#$%^&*()_\-=*+/~|?]{8,20}$/i
);

export const validateEmail = (email) => {
  const emailRegex = /^(?=[a-zA-Z0-9._+-]*[a-zA-Z0-9])[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
